module.exports = [{"title":"1.0.1","changelog":"https://github.com/binstd/bytom"}]


//////////////////
// WEBPACK FOOTER
// ./content/versions.yml
// module id = 1043
// module chunks = 68244379756336